import './App.css'
import 'prismjs';
import React from "react";
import Dashboard from "./components/Dashboard";
import { TimezoneProvider } from "./contexts/TimezoneContext";

function App() {
    return (
        <TimezoneProvider>
            <Dashboard />
        </TimezoneProvider>
    );
}

export default App
